import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { PiniaColada } from '@pinia/colada'

// Import the main ADX app component
import App from './App.vue'

// Import ADX router
import router from './router'

// Import configured Vuetify instance
import vuetify from './plugins/vuetify'
// Import auth plugin (initializes Cognito + provides $auth)
import { authPlugin } from './plugins/auth'
// Import i18n for translations
import i18n from './plugins/i18n'
// Import maska for input masking
import { vMaska } from 'maska/vue'
// Import DOMPurify HTML directive (used by Wasabi components)
import VueDOMPurifyHTML from 'vue-dompurify-html'
// Import layout styles
import './assets/scss/layouts.scss'
import './assets/scss/claude-area.scss'
// CustomScrollbar styles (used by WDrawer)
import 'custom-vue-scrollbar/dist/style.css'

// Create Pinia store
const pinia = createPinia()

// Create and mount the app
const app = createApp(App)

app.use(pinia)
app.use(PiniaColada, {
  pinia,
  queryOptions: {
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false
  }
})
app.use(router)
app.use(authPlugin)
app.use(vuetify)
app.use(i18n)
app.use(VueDOMPurifyHTML)
// Register maska directive
app.directive('maska', vMaska)

app.mount('#app')

// MODE is replaced at build time, so a production bundle drops the module whatever the flag says.
if (import.meta.env.MODE !== 'production' && import.meta.env.VITE_WEBMCP === 'true') {
  void import('./services/webmcp').then(({ registerWebMcpTools }) => registerWebMcpTools(router))
}
